<template>
  <div class="all-alerts-page-wrapper">
    <AllAlertsPage />
  </div>
</template>

<script>
import AllAlertsPage from './components/AllAlertsPage.vue'

export default {
  name: 'AllAlertsPageWrapper',
  components: {
    AllAlertsPage
  }
}
</script>

<style scoped>
.all-alerts-page-wrapper {
  min-height: 100vh;
  background: #ffffff;
}
</style>




// WEBPACK FOOTER //
// AllAlertsPageWrapper.vue?204d436a